import React, { Dispatch, SetStateAction, useState } from "react";
import BasicDataTable from "../../../Component/BasicComponents/BasicDataTable";
import RoundedDropdown from "../../../Component/BasicComponents/Dropdowns/RoundedDropdown";
import { FaEdit, FaEye } from "react-icons/fa";
import { useTicketConfigStatus, useTicketList } from "../hooks/useTicket";
import { useNavigate } from "react-router-dom";

interface TicketListProps {
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
  setSelectedRow?: any;
  ticketConfigStatus?: any;
  setModalStatus?: any;
}

const TicketList: React.FC<TicketListProps> = ({
  setIsModalOpen,
  setSelectedRow,
  ticketConfigStatus,
  setModalStatus,
}) => {
  const navigate = useNavigate();
  const [filtersState, setFiltersState] = useState<any>({
    page: 1,
    limit: 10,
    search: null,
    status: "",
  });

  const { data: TicketType, isLoading: ticketTypeLoading } = useTicketList({
    enable: true,
    params: {
      search: filtersState?.search,
      start: filtersState?.page,
      length: filtersState?.limit,
      Status: filtersState?.status,
      sortColumn: "CreatedAt",
      sortOrder: "desc",
    },
  });

  let formattedConfigStatusData = [
    { id: "", label: "All" },
    ...Object.entries(ticketConfigStatus?.data || {}).map(([key, value]) => ({
      id: key,
      label: value,
    })),
  ];

  // ========== pagination Function =============

  const handlePagination = (pageNo: number) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  };
  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
        limit: limit,
      };
    });
  };
  const handleSearch = (searchValue: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        search: searchValue,
      };
    });
  };

  // ============= Filter Function ===============
  const handleFilter = (key: any, selected: any) => {
    setFiltersState((prev: any) => ({
      ...prev,
      [key]: selected.id === "null" ? null : selected.id,
    }));
  };

  const handleEdit = (row: any) => {
    console.log("🚀 ~ TIcketList.tsx:119 ~ handleEdit ~ row:", row);
    setIsModalOpen?.(true);
    setSelectedRow(row);
    setModalStatus("Edit");
  };

  const handleView = (row: any) => {
    console.log("🚀 ~ TIcketList.tsx:92 ~ handleView ~ row:", row);
    navigate("/tickets/ticketsReplies", { state: { rowData: row } });
  };

  return (
    <BasicDataTable
      Title="Tickets"
      columns={TicketListColumns(handleEdit, handleView)}
      data={TicketType?.data?.data || []}
      search={true}
      dynamicHeightOnRowsPerPage={true}
      showSpinner={ticketTypeLoading}
      SearchPlaceholder={"Search by Outlet,Ticket Type"}
      headerContent={
        <div>
          <RoundedDropdown
            options={formattedConfigStatusData || []}
            onSelect={(e) => handleFilter("status", e)}
            defaultLabel="All"
            width="120px"
            isShowHeading
            DropdownHeading="Ticket Status"
            headingColor="#2e8dd3"
          />
        </div>
      }
      onChangePage={(pageNo: number) => {
        handlePagination(pageNo);
      }}
      onChangeRowsPerPage={(newPerPage: any, page: any) => {
        handleonChangeRowsPerPage(newPerPage, page);
      }}
      handleSearch={(val: any) => {
        handleSearch(val);
      }}
      paginationTotalRows={TicketType?.data?.recordsTotal || 0}
    />
  );
};
export default TicketList;

const TicketListColumns = (
  handleEdit: (row: any) => void,
  handleView: (row: any) => void
) => [
  {
    name: "Ticket Type",
    selector: (row: { TicketType: string }) => row?.TicketType || "-",
    sortable: true,
    wrap: true,
    maxWidth: "180px",
  },
  {
    name: "Outlet",
    selector: (row: { OutletName: string }) => row.OutletName || "-",
    sortable: true,
    wrap: true,
    maxWidth: "180px",
  },
  {
    name: "Emp Name | Emp Code",
    selector: (row: any) => {
      const firstName = row?.FirstName;
      const lastName = row?.LastName;
      const employeeCode = row?.EmployeeCode;
      const fullNameWithEmpCode = `${firstName}${lastName} | ${employeeCode}`;
      return fullNameWithEmpCode;
    },
    sortable: true,
    wrap: true,
    maxWidth: "250px",
  },
  {
    name: "Description",
    selector: (row: { Description: string }) => row?.Description || "-",
    sortable: true,
    wrap: true,
    maxWidth: "220px",
  },
  {
    name: "Status",
    selector: (row: { Status: string }) => row?.Status || "-",
    sortable: true,
    wrap: true,
    maxWidth: "180px",
  },
  {
    name: "Action",
    cell: (row: { id: string }) => (
      <div
        style={{
          width: "330px",
          display: "flex",
          flexDirection: "row",
          gap: "5px",
        }}
      >
        <button
          onClick={() => handleEdit(row)}
          className="btn btn-primary"
          style={{
            borderRadius: "20px",
            padding: "5px",
            width: "80px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "2px",
          }}
        >
          <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
        </button>
        <button
          onClick={() => handleView(row)}
          className="btn btn-primary"
          style={{
            borderRadius: "20px",
            padding: "5px",
            width: "80px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "2px",
            backgroundColor: "#2e8dd3",
          }}
        >
          <FaEye style={{ fill: "#fff" }} /> View
        </button>
      </div>
    ),
    maxWidth: "250px",
  },
];
